import * as React from "react"

function HomeIcon(props) {
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M23.503 10.82L12.6.24A.848.848 0 0012 0a.867.867 0 00-.599.24L.498 10.82A1.624 1.624 0 000 11.984c0 .907.76 1.645 1.694 1.645h1.15v7.548c0 .456.378.823.846.823h6.616v-5.757h2.965V22h7.04a.834.834 0 00.847-.823V13.63h1.149c.45 0 .881-.172 1.199-.483.66-.643.66-1.684-.003-2.326z"
                fill={props.fill}
            />
        </svg>
    )
}

export default HomeIcon
